module.exports = __webpack_public_path__ + "static/media/pinterest.91bae247.svg";